module.exports = __webpack_public_path__ + "fonts/HKGrotesk-ExtraBold.9365523.otf";